/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminStockTransfer
 */
export interface InputAdminStockTransfer {
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockTransfer
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockTransfer
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockTransfer
     */
    stockItemId: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockTransfer
     */
    toPositionId: number;
}

/**
 * Check if a given object implements the InputAdminStockTransfer interface.
 */
export function instanceOfInputAdminStockTransfer(value: object): boolean {
    if (!('quantity' in value)) return false;
    if (!('stockItemId' in value)) return false;
    if (!('toPositionId' in value)) return false;
    return true;
}

export function InputAdminStockTransferFromJSON(json: any): InputAdminStockTransfer {
    return InputAdminStockTransferFromJSONTyped(json, false);
}

export function InputAdminStockTransferFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminStockTransfer {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'quantity': json['quantity'],
        'stockItemId': json['stockItemId'],
        'toPositionId': json['toPositionId'],
    };
}

export function InputAdminStockTransferToJSON(value?: InputAdminStockTransfer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'quantity': value['quantity'],
        'stockItemId': value['stockItemId'],
        'toPositionId': value['toPositionId'],
    };
}

